import { useEffect } from 'react';
import { FormikProps, useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

import { useAuthForgotPasswordMutation } from 'store/apis/auth.api';

interface UseAuthForgotPasswordFormManagerProps {
  next?: (data?: any) => void;
}

export const useAuthForgotPasswordFormManager = ({ next = () => {} }: UseAuthForgotPasswordFormManagerProps) => {
  const [forgotPassword, { isLoading, isSuccess, isError, error }] = useAuthForgotPasswordMutation();

  const initialValues = {
    email: '',
  };

  const validationSchema = Yup.object({
    email: Yup.string().required('Email is required').email('Invalid email address'),
  });

  const formManager = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      forgotPassword(values);
    },
  });

  useEffect(() => {
    if (isError) {
      toast.error((error as any)?.data?.payload?.message);
    }

    if (!isLoading && isSuccess && !isError) {
      toast.success('We have emailed your password reset link.');

      next();
    }
  }, [isLoading, isSuccess, isError]);

  return [
    {
      formManager,
      loading_submit: isLoading,
    },
  ] as [
    {
      formManager: FormikProps<typeof initialValues>;
      loading_submit: boolean;
    },
  ];
};
